// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

import { type Variant } from '../../types';

const padding: Record<Variant, ReturnType<typeof token>> = {
	default: token('space.100', '8px'),
	compact: token('space.050', '4px'),
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const ActionsWrapper = styled(Flex)<{ variant: Variant }>((props) => ({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingBottom: padding[props.variant],
}));
